/**
 * @file Shared React component — components/common/Dropdown.tsx.
 */

// src/components/common/Dropdown.tsx
import React from "react";
import "./Dropdown.css";
import FormFieldLabel from "./FormFieldLabel";

/** Type definition — Dropdown Option. */
export interface DropdownOption {
  label: string;
  value: string;
}

/** Type definition — Dropdown Props. */
export interface DropdownProps {
  label: string;
  name: string;
  options: DropdownOption[];
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  infoText?: string | null; // Info text to display in tooltip
  error?: string; // Error message to display
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  name,
  options,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = "Select an option",
  className = "",
  infoText,
  error,
}) => {
  return (
    <div className={`form-group ${className}`}>
      <FormFieldLabel
        label={label}
        htmlFor={name}
        required={required}
        infoText={infoText}
      />

      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={`dropdown-input ${disabled ? "disabled" : ""} ${error ? "error" : ""}`}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

/** React component — Dropdown. */
export default Dropdown;